export default __webpack_public_path__ + "static/media/logo-cordoba-blanco.59eb648d.svg";